import { Pipe, type PipeTransform } from '@angular/core';
import { range } from 'es-toolkit/compat';

@Pipe({
    name: 'toRange',
    standalone: true,
})
export class ToRangePipe implements PipeTransform {
    transform(value: number): number[] {
        return range(value);
    }
}
